
import { restApi } from '@/components/mixins/restApi';
import {
	ICredentialsResponse,
	INodeUi,
	INodeUpdatePropertiesInformation,
} from '@/Interface';
import {
	ICredentialType,
	INodeCredentialDescription,
	INodeCredentialsDetails,
	NodeParameterValue,
	INodeTypeDescription,
} from 'n8n-workflow';


import ScrollInfinite from '@/components/ScrollInfinite.vue';
import { USE_LEGACY_AUTH_PARAMETER } from '@/constants';

import { genericHelpers } from '@/components/mixins/genericHelpers';
import { nodeHelpers } from '@/components/mixins/nodeHelpers';
import { workflowHelpers } from '@/components/mixins/workflowHelpers';
import { showMessage } from '@/components/mixins/showMessage';

import { mapGetters } from "vuex";

import mixins from 'vue-typed-mixins';

export default mixins(
	genericHelpers,
	nodeHelpers,
	restApi,
	showMessage,
	workflowHelpers,
).extend({
	name: 'NodeCredentials',
	components: {
		ScrollInfinite,
	},
	props: [
		'node', // INodeUi
	],
	data () {
		return {
			NEW_CREDENTIALS_TEXT: '',
			newCredentialUnsubscribe: null as null | (() => void),
			typeName: '',
			searchName: '',
			searchDebounceTimeout: null as null | number,
			credentialIdSelected: '',
			credentialOptions: '',
			isFocused: false,
			isLoadingOptions: false,
			loadingSelectedCredential: false,
			showScrollInfinite: true,
			credentialExpressions: {} as {[key: string]: string},
			page: 1,
		};
	},
	computed: {
		credentialTypesNode (): string[] {
			return this.credentialTypesNodeDescription
				.map((credentialTypeDescription: INodeCredentialDescription) => credentialTypeDescription.name);
		},
		credentialTypesNodeDescriptionDisplayed (): INodeCredentialDescription[] {
			return this.credentialTypesNodeDescription
				.filter((credentialTypeDescription: INodeCredentialDescription) => {
					return this.displayCredentials(credentialTypeDescription);
				});
		},
		credentialTypesNodeDescription (): INodeCredentialDescription[] {
			const node = this.node as INodeUi;

			const activeNodeType = this.$store.getters.nodeType(node.type, node.typeVersion) as INodeTypeDescription | null;
			if (activeNodeType && activeNodeType.credentials) {
				return activeNodeType.credentials;
			}

			return [];
		},
		credentialTypeNames () {
			const returnData: {
				[key: string]: string;
			} = {};
			let credentialType: ICredentialType | null;
			for (const credentialTypeName of this.credentialTypesNode) {
				credentialType = this.$store.getters['credentials/getCredentialTypeByName'](credentialTypeName);
				returnData[credentialTypeName] = credentialType !== null ? credentialType.displayName : credentialTypeName;
			}
			return returnData;
		},
		selected(): {[type: string]: INodeCredentialsDetails} {
			return this.node.credentials || {};
		},
		workspace() {
			return this.$store.getters.workspace;
		},
	},
	methods: {
		drop(credentialType: string, ev: DragEvent) {
			ev.preventDefault();
			const data = JSON.parse(ev.dataTransfer?.getData('text') || '{}');
			if (!data.key || !data.value) {

				this.$store.commit('activeAlert', {
					message: 'O parâmetro está vazio ou não é valido.',
					status: 'error',
				});
				return;
			}

			this.onExpressionInputHandler(credentialType, `={{${data.key}}}`)
			// this.valueChanged(`={{${data.key}}}`);

		},
		allowDrop(ev: DragEvent) {
			ev.preventDefault();
		},
		async applyCredential(credentialType: string) {
			try {
				const selectedCredentials = await this.restApi().getCredentialById(this.workspace.id, this.credentialIdSelected);

				const selected = { id: parseInt(selectedCredentials.credencialData.id), name: selectedCredentials.tipo, idAliare: selectedCredentials.id};

				this.$emit('applyCredentialAllNodeSameType', {
					nodeType: this.node.type,
					credentialType,
					credential: selected,
					useLegacyAuth: this.node.parameters[USE_LEGACY_AUTH_PARAMETER],
				});
			} catch (e) {
				console.error(e);
			}
		},
		onCredentialSearch(value: string) {
			if (!this.isFocused) {
				return;
			}

			if (this.searchDebounceTimeout) {
				window.clearTimeout(this.searchDebounceTimeout);
			}

			this.searchDebounceTimeout = window.setTimeout(async () => {
				this.searchName = value || '';
				this.page = 1;
				this.showScrollInfinite = true;
				this.isLoadingOptions = true;
				await this.getCredentialOptions();
				this.isLoadingOptions = false;
			}, 300);
		},
		async onFocus(credentialType: string, visible: boolean) {
			this.typeName = credentialType;
			this.isFocused = visible;
			if (this.isFocused)  {
				this.searchName = '';
				this.isLoadingOptions = true;
				await this.getCredentialOptions();
				this.isLoadingOptions = false;
			};
		},
		async getCredentialSelected() {
			this.loadingSelectedCredential = true;
			const credentialSelected = await this.restApi().getCredentials(this.workspace.id, {integracaoId: this.node.credentials[this.typeName].id});

			if (credentialSelected.length) {
				this.credentialOptions = credentialSelected;
				this.credentialIdSelected = credentialSelected[0].id;
			} else {
				this.updateNodesCredentialsIssues();
			}

			this.loadingSelectedCredential = false;
		},
		async getCredentialOptions(options:{ scrollInfinite: Boolean }){
			if (options?.scrollInfinite) {
				this.page++;
			} else {
				this.page = 1;
			}
			const payload: {[key: string]: string | number} = {
				tipo: this.typeName,
				page: this.page,
			};

			if (this.searchName.trim()) {
				payload.searchNome = this.searchName.trim();
			}

			const credentials = await this.restApi().getCredentials(this.workspace.id, payload);
			if (options?.scrollInfinite) {
				this.credentialOptions.push(...credentials);

				if (credentials?.length < 10) {
					this.showScrollInfinite = false;
				}
			} else {
				this.credentialOptions = credentials;
				this.showScrollInfinite = true;
			}
		},
		credentialInputWrapperStyle (credentialType: string) {
			let deductWidth = 0;
			const styles = {
				width: '100%',
			};
			if (this.getIssues(credentialType).length) {
				deductWidth += 20;
			}

			if (deductWidth !== 0) {
				styles.width = `calc(100% - ${deductWidth}px)`;
			}

			return styles;
		},

		listenForNewCredentials(credentialType: string) {
			this.stopListeningForNewCredentials();

		this.newCredentialUnsubscribe = this.$store.subscribe((mutation: any, state: any) => {
				if (mutation.type === 'credentials/upsertCredential' || mutation.type === 'credentials/enableOAuthCredential'){
					this.onCredentialSelected(credentialType, mutation.payload.id);
				}
				if (mutation.type === 'credentials/deleteCredential') {
					this.clearSelectedCredential(credentialType);
					this.stopListeningForNewCredentials();
				}
			});
		},

		stopListeningForNewCredentials() {
			if (this.newCredentialUnsubscribe) {
				this.newCredentialUnsubscribe();
			}
		},

		clearSelectedCredential(credentialType: string) {
			const node: INodeUi = this.node;

			const credentials = {
				...(node.credentials || {}),
			};

			delete credentials[credentialType];

			const updateInformation: INodeUpdatePropertiesInformation = {
				name: this.node.name,
				properties: {
					credentials,
				},
			};

			this.$emit('credentialSelected', updateInformation);
		},

		async onCredentialSelected (credentialType: string, credentialId: string | null | undefined) {
			if (credentialId === this.NEW_CREDENTIALS_TEXT) {
				this.listenForNewCredentials(credentialType);
				this.$store.dispatch('ui/openNewCredential', { type: credentialType });
				this.$telemetry.track('User opened Credential modal', { credential_type: credentialType, source: 'node', new_credential: true, workflow_id: this.$store.getters.workflowId });
				return;
			}
			this.loadingSelectedCredential = true;
			this.credentialIdSelected = '';

			await this.$store.dispatch('credentials/fetchAllCredentials');


			this.$telemetry.track('User selected credential from node modal', { credential_type: credentialType, workflow_id: this.$store.getters.workflowId });

			const selectedCredentials = await this.restApi().getCredentialById(this.workspace.id, credentialId);
			const oldCredentials = {
				name: '',
				id: '',
			};

			const selected = { id: parseInt(selectedCredentials.credencialData.id), name: selectedCredentials.tipo, idAliare: selectedCredentials.id};

			// if credentials has been string or neither id matched nor name matched uniquely
			if (oldCredentials.id === null || (oldCredentials.id && !this.$store.getters['credentials/getCredentialByIdAndType'](oldCredentials.id, credentialType))) {
				// update all nodes in the workflow with the same old/invalid credentials
				this.$store.commit('replaceInvalidWorkflowCredentials', {
					credentials: selected,
					invalid: oldCredentials,
					type: credentialType,
				});
				this.updateNodesCredentialsIssues();

				this.$store.commit('activeAlert', {
					message: this.$locale.baseText(
						'nodeCredentials.showMessage.message',
						{
							interpolate: {
								oldCredentialName: oldCredentials.name,
								newCredentialName: selected.name,
							},
						},
					),
				});
			}

			const node: INodeUi = this.node;

			const credentials = {
				...(node.credentials || {}),
				[credentialType]: selected,
			};

			const updateInformation: INodeUpdatePropertiesInformation = {
				name: this.node.name,
				properties: {
					credentials,
				},
			};
			this.$emit('credentialSelected', updateInformation);
			this.credentialOptions = [selectedCredentials];
			this.credentialIdSelected = selectedCredentials.id;

			this.loadingSelectedCredential = false;
		},

		displayCredentials (credentialTypeDescription: INodeCredentialDescription): boolean {
			if (credentialTypeDescription.displayOptions === undefined) {
				// If it is not defined no need to do a proper check
				return true;
			}
			return this.displayParameter(this.node.parameters, credentialTypeDescription, '');
		},

		getIssues (credentialTypeName: string): string[] {
			const node = this.node as INodeUi;

			if (node.issues === undefined || node.issues.credentials === undefined) {
				return [];
			}

			if (!node.issues.credentials.hasOwnProperty(credentialTypeName)) {
				return [];
			}

			if (this.isCredentialExpression(credentialTypeName)) {
				return [];
			}

			return node.issues.credentials[credentialTypeName];
		},

		async isCredentialExisting(credentialType: string): Promise<boolean> {
			if (!this.node.credentials || !this.node.credentials[credentialType] || !this.node.credentials[credentialType].id) {
				return false;
			}
			const id = this.node.credentials[credentialType].idAliare;
			if (id) {
				const selectedCredentials = await this.restApi().getCredentialById(this.workspace.id, id);
				return selectedCredentials;
			} else {
				return false;
			};
		},

		editCredential(credentialType: string): void {

			this.$store.dispatch('ui/openExisitngCredential', {id: this.credentialIdSelected});

			this.$telemetry.track('User opened Credential modal', { credential_type: credentialType, source: 'node', new_credential: false, workflow_id: this.$store.getters.workflowId });

			this.listenForNewCredentials(credentialType);
		},

		isCredentialExpression(credentialType: string): boolean {
			return this.credentialExpressions[credentialType] !== undefined;
		},

		getCredentialExpression(credentialType: string): string {
			return this.credentialExpressions[credentialType] || '';
		},

		onExpressionInput(credentialType: string, value: string) {
			// Se o valor está vazio, remove a expressão e volta para o select
			if (!value || value.trim() === '') {
				this.handleOptionCommand('removeExpression', credentialType);
				return;
			}

			// Garantir que o valor comece com '=' (padrão n8n para expressões)
			const expressionValue = value.startsWith('=') ? value : `=${value}`;
			
			// Atualizar o estado local
			this.$set(this.credentialExpressions, credentialType, expressionValue);
			
			// Salvar a expressão como credencial no nó
			const node: INodeUi = this.node;
			const credentials = {
				...(node.credentials || {}),
				[credentialType]: {
					id: expressionValue,  // O id contém a expressão
					name: credentialType,
				},
			};

			const updateInformation: INodeUpdatePropertiesInformation = {
				name: this.node.name,
				properties: {
					credentials,
				},
			};

			this.$emit('credentialSelected', updateInformation);
		},

		getExpressionResult(credentialType: string): string {
			const expression = this.credentialExpressions[credentialType];
			if (!expression) {
				return '';
			}

			try {
				// Tentar resolver a expressão
				const result = this.resolveExpression(expression) as NodeParameterValue;;
				return String(result || '');
			} catch (error) {
				const err = error as Error;
				return `[Erro: ${err.message}]`;
			}
		},

		handleOptionCommand(command: string, credentialType: string) {
			if (command === 'addExpression') {
				// Adicionar expressão
				this.$set(this.credentialExpressions, credentialType, '=');
				this.credentialIdSelected = '';
			} else if (command === 'removeExpression') {
				// Remover expressão
				this.$delete(this.credentialExpressions, credentialType);
				
				// Limpar credencial
				this.clearSelectedCredential(credentialType);
			} else if (command === 'editCredential') {
				this.editCredential(credentialType);
			} else if (command === 'applyCredential') {
				this.applyCredential(credentialType);
			}
		},

		// Métodos wrapper para eventos do template (Vue não aceita tipos inline)
		onExpressionInputHandler(credentialType: string, value: string) {
			this.onExpressionInput(credentialType, value);
		},

		onCredentialSelectedHandler(credentialType: string, value: string | null | undefined) {
			this.onCredentialSelected(credentialType, value);
		},

		handleOptionCommandHandler(credentialType: string, command: string) {
			this.handleOptionCommand(command, credentialType);
		},
	},
	mounted() {
		this.NEW_CREDENTIALS_TEXT = `- ${this.$locale.baseText('nodeCredentials.createNew')} -`;
		
		if(this.credentialTypesNodeDescriptionDisplayed.length) {
			this.typeName = this.credentialTypesNodeDescriptionDisplayed[0].name;
			//this.getCredentialOptions();
		}
		if (this.node.credentials && Object.keys(this.node.credentials).length) {
			// Carregar expressões existentes
			// Se o id começa com '=', é uma expressão (padrão n8n)
			for (const credType in this.node.credentials) {
				const cred = this.node.credentials[credType];
				if (cred && typeof cred.id === 'string' && cred.id.startsWith('=')) {
					// É uma expressão, carregar no estado local
					this.$set(this.credentialExpressions, credType, cred.id);
				}
			}
			
			// Só carregar credenciais selecionadas se não for expressão
			const hasNonExpressionCredentials = Object.keys(this.node.credentials).some(
				credType => !this.isCredentialExpression(credType)
			);
			
			if (hasNonExpressionCredentials) {
				this.getCredentialSelected();
			}
		}
	},
	watch: {
		credentialTypesNodeDescriptionDisplayed(newValue: INodeCredentialDescription[], oldValue: INodeCredentialDescription[]) {
			const newNames = newValue.map(credential => credential.name).join(',');
			const oldNames = (oldValue || []).map(credential => credential.name).join(',');
			if (newNames === oldNames) {
				return;
			}

			// Ex.: alternar "useLegacyAuth" troca o tipo de credencial exibido
			this.credentialIdSelected = '';
			this.credentialOptions = [];
			this.showScrollInfinite = true;
			this.typeName = newValue.length ? newValue[0].name : '';

			for (const credType of Object.keys(this.credentialExpressions)) {
				if (!this.node.credentials || !this.node.credentials[credType]) {
					this.$delete(this.credentialExpressions, credType);
				}
			}
		},
	},
	beforeDestroy () {
		if (this.searchDebounceTimeout) {
			window.clearTimeout(this.searchDebounceTimeout);
		}
		this.stopListeningForNewCredentials();
	},
});
